// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/cis_contract_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExportCisContractsRow, ImportCisContractsRowResult, ImportCisContractsSummary } from "./cis_contract_model_pb";
import { file_bffuser_v1_cis_contract_model } from "./cis_contract_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/cis_contract_service.proto.
 */
export const file_bffuser_v1_cis_contract_service: GenFile = /*@__PURE__*/
  fileDesc("CiViZmZ1c2VyL3YxL2Npc19jb250cmFjdF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIm4KGUltcG9ydENpc0NvbnRyYWN0c1JlcXVlc3QSHQoHY29udGVudBgBIAEoDEIMukgJegcQARiAgIAKEg8KB2RyeV9ydW4YAiABKAgSIQoNY3N2X2ZpbGVfbmFtZRgDIAEoCUIKukgHcgUQARj/ASKjAQoaSW1wb3J0Q2lzQ29udHJhY3RzUmVzcG9uc2USDwoHYXBwbGllZBgBIAEoCBI8Cgtyb3dfcmVzdWx0cxgCIAMoCzInLmJmZnVzZXIudjEuSW1wb3J0Q2lzQ29udHJhY3RzUm93UmVzdWx0EjYKB3N1bW1hcnkYAyABKAsyJS5iZmZ1c2VyLnYxLkltcG9ydENpc0NvbnRyYWN0c1N1bW1hcnkiGwoZRXhwb3J0Q2lzQ29udHJhY3RzUmVxdWVzdCKbAQoaRXhwb3J0Q2lzQ29udHJhY3RzUmVzcG9uc2USLwoEcm93cxgBIAMoCzIhLmJmZnVzZXIudjEuRXhwb3J0Q2lzQ29udHJhY3RzUm93EjgKD2RhdGFfdXBkYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBAUISChBfZGF0YV91cGRhdGVkX2F0Mt4BChJDaXNDb250cmFjdFNlcnZpY2USYwoSSW1wb3J0Q2lzQ29udHJhY3RzEiUuYmZmdXNlci52MS5JbXBvcnRDaXNDb250cmFjdHNSZXF1ZXN0GiYuYmZmdXNlci52MS5JbXBvcnRDaXNDb250cmFjdHNSZXNwb25zZRJjChJFeHBvcnRDaXNDb250cmFjdHMSJS5iZmZ1c2VyLnYxLkV4cG9ydENpc0NvbnRyYWN0c1JlcXVlc3QaJi5iZmZ1c2VyLnYxLkV4cG9ydENpc0NvbnRyYWN0c1Jlc3BvbnNlQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_bffuser_v1_cis_contract_model, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * ImportCisContractsRequest は CSV を生バイト列で受ける (行配列でない理由は
 * internalapi 側 cis_contract_service.proto の同名 message doc が SoT)。
 *
 * @generated from message bffuser.v1.ImportCisContractsRequest
 */
export type ImportCisContractsRequest = Message<"bffuser.v1.ImportCisContractsRequest"> & {
  /**
   * CSV の生バイト列 (UTF-8 BOM / UTF-8 / Shift_JIS)。上限 20 MB
   * (common.md 非機能要件。行数・削除件数の上限は設けない)。
   *
   * @generated from field: bytes content = 1;
   */
  content: Uint8Array;

  /**
   * true = プレビュー (Step2)、false = 確定 (Step3)。
   *
   * @generated from field: bool dry_run = 2;
   */
  dryRun: boolean;

  /**
   * 削除元 CSV ファイル名 (AC-DUI-013: 監査に記録)。上限は
   * csv_upload_history.csv_file_name へ記録する他経路と同じ 255。
   *
   * @generated from field: string csv_file_name = 3;
   */
  csvFileName: string;
};

/**
 * Describes the message bffuser.v1.ImportCisContractsRequest.
 * Use `create(ImportCisContractsRequestSchema)` to create a new message.
 */
export const ImportCisContractsRequestSchema: GenMessage<ImportCisContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_service, 0);

/**
 * @generated from message bffuser.v1.ImportCisContractsResponse
 */
export type ImportCisContractsResponse = Message<"bffuser.v1.ImportCisContractsResponse"> & {
  /**
   * @generated from field: bool applied = 1;
   */
  applied: boolean;

  /**
   * 非据え置き行 (新規 / 変更 / 削除 / エラー) のみ。据え置き行は summary の
   * unchanged_row_count に件数だけ載る。
   *
   * @generated from field: repeated bffuser.v1.ImportCisContractsRowResult row_results = 2;
   */
  rowResults: ImportCisContractsRowResult[];

  /**
   * @generated from field: bffuser.v1.ImportCisContractsSummary summary = 3;
   */
  summary?: ImportCisContractsSummary;
};

/**
 * Describes the message bffuser.v1.ImportCisContractsResponse.
 * Use `create(ImportCisContractsResponseSchema)` to create a new message.
 */
export const ImportCisContractsResponseSchema: GenMessage<ImportCisContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_service, 1);

/**
 * 絞り込み条件を持たない (= 全件エクスポートが本 RPC の契約)。
 *
 * @generated from message bffuser.v1.ExportCisContractsRequest
 */
export type ExportCisContractsRequest = Message<"bffuser.v1.ExportCisContractsRequest"> & {
};

/**
 * Describes the message bffuser.v1.ExportCisContractsRequest.
 * Use `create(ExportCisContractsRequestSchema)` to create a new message.
 */
export const ExportCisContractsRequestSchema: GenMessage<ExportCisContractsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_service, 2);

/**
 * @generated from message bffuser.v1.ExportCisContractsResponse
 */
export type ExportCisContractsResponse = Message<"bffuser.v1.ExportCisContractsResponse"> & {
  /**
   * 論理削除されていない供給地点マスタ全行。順序は
   * (supply_point_specific_number, start_date) の昇順で決定的。
   *
   * @generated from field: repeated bffuser.v1.ExportCisContractsRow rows = 1;
   */
  rows: ExportCisContractsRow[];

  /**
   * 出力対象の最終更新時刻 (= 全行の updated_at の最大値)。ダウンロード確認
   * モーダルの「基準時点」に表示する (uploads/common.md AC-DUC-032)。
   * 0 件のときは未設定。
   *
   * @generated from field: optional google.protobuf.Timestamp data_updated_at = 2;
   */
  dataUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ExportCisContractsResponse.
 * Use `create(ExportCisContractsResponseSchema)` to create a new message.
 */
export const ExportCisContractsResponseSchema: GenMessage<ExportCisContractsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_cis_contract_service, 3);

/**
 * @generated from service bffuser.v1.CisContractService
 */
export const CisContractService: GenService<{
  /**
   * ImportCisContracts は CIS契約マスタ CSV 取込を検証・反映する
   * (docs/specs/admin/data/uploads/cis-contract-master.md)。acting_member_id は
   * 露出させず BFF が eauth セッションから補完する。
   *
   * @generated from rpc bffuser.v1.CisContractService.ImportCisContracts
   */
  importCisContracts: {
    methodKind: "unary";
    input: typeof ImportCisContractsRequestSchema;
    output: typeof ImportCisContractsResponseSchema;
  },
  /**
   * ExportCisContracts は組織内の論理削除されていない供給地点マスタ (CIS契約マスタ)
   * 全行を CSV エクスポート用に返す (uploads/common.md §6, AC-DUC-028/029)。
   *
   * @generated from rpc bffuser.v1.CisContractService.ExportCisContracts
   */
  exportCisContracts: {
    methodKind: "unary";
    input: typeof ExportCisContractsRequestSchema;
    output: typeof ExportCisContractsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_cis_contract_service, 0);

